<template lang="pug">
#modal-dados-cadastro-manual
    el-dialog(
        width='986px',
        title='Inserir volume',
        :close-on-click-modal='false',
        :visible.sync='mostrar',
        :before-close='fechar',
        append-to-body,
        :show-close='false'
    )
        .bloco-modal-dados-cadastro-manual-dados
            .bloco-modal-dados-cadastro-manual__informacoes
                .bloco-modal-dados-cadastro-manual__informacao
                    p
                        b Número do CAR
                    p {{ territorio.carNumero }}

                .bloco-modal-dados-cadastro-manual__informacao
                    p
                        b CPF/CNPJ
                    p {{ territorio.cpfCnpj }}

                el-form(
                    label-position='top',
                    :model='formularioVolumeTerritorio',
                    :rules='rules',
                    ref='formularioVolumeTerritorio'
                )
                    el-form-item(prop='volume')
                        template(slot='label')
                            span Informe o volume (em toneladas)

                        el-input(
                            v-model='formularioVolumeTerritorio.volume',
                            type='number',
                            placeholder='Digite o volume'
                        )

            .bloco-modal-dados-cadastro-manual__mapa
                #map

        footer.espaco-modal-dados(slot='footer')
            el-button(type='primary', @click.prevent='confirmar') Confirmar
</template>

<script>
import L from 'leaflet';
import { TILE_LAYER_CONFIG } from '@/utils/mapa/mapa.config';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';

export default {
    name: 'ModalDadosCadastroManual',

    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        territorio: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            geometria: [],
            idMapa: 'mapaDefinirVolume',
            formularioVolumeTerritorio: {
                volume: ''
            },
            rules: {
                volume: [
                    {
                        required: true,
                        message: 'Informe um volume',
                        trigger: 'blur'
                    }
                ]
            }
        };
    },

    watch: {
        mostrar: function () {
            setTimeout(() => this.criarMapa(), 300);
        }
    },

    mounted() {
        setTimeout(() => this.criarMapa(), 300);
    },

    methods: {
        fechar() {
            this.$emit('fechar');
        },

        criarMapa() {
            if (this.mostrar) {
                const map = L.map('map', {
                    center: [53.2, -1.7],
                    zoom: 6,
                    zoomControl: false,
                    dragging: false,
                    scrollWheelZoom: false,
                    doubleClickZoom: false,
                    boxZoom: false,
                    tap: false,
                    touchZoom: false
                });

                L.tileLayer(TILE_LAYER_CONFIG.url).addTo(map);

                var geometria = L.geoJson(
                    this.territorio.geometria,
                    getEstiloGeometria('area')
                ).addTo(map);

                map.fitBounds(geometria.getBounds());
            }
        },

        confirmar() {
            this.$refs['formularioVolumeTerritorio'].validate(valid => {
                if (valid) {
                    this.$emit(
                        'definir-volume',
                        this.formularioVolumeTerritorio.volume
                    );
                } else {
                    return false;
                }
            });
        }
    }
};
</script>

<style lang="scss">
.bloco-modal-dados-cadastro-manual-dados {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    gap: 24px;

    .bloco-modal-dados-cadastro-manual__informacoes {
        display: flex;
        flex-direction: column;
        align-content: space-between;
        gap: 7px;
        justify-content: center;

        .el-form-item .el-form-item__label {
            color: var(--text-disabled);
        }

        p.bloco-modal-dados-cadastro-manual__informacao {
            margin-bottom: 4px;
        }
    }
    .el-dialog__title {
        font-size: 21px;
    }
}

footer {
    display: flex;
    justify-content: flex-end;
}

.invalido {
    color: var(--danger);
}

.espaco-modal-dados {
    display: flex;
    padding-right: 20px;
}

#map {
    height: 322px;
    width: 484px;
    border-radius: 10px;
    .leaflet-top.leaflet-right {
        overflow-y: hidden;
        background-color: transparent;
    }
    .leaflet-control-attribution.leaflet-control {
        display: none;
    }
}
</style>
